<div class="calls-history-wrap">
  <ng-container *ngIf="columns">
    <ion-grid>
      <ion-row class="table-header">
        <ion-col *ngFor="let column of columns">{{ column.header }}</ion-col>
        <ion-col>{{ "__CALLS_ACTION__" | translate }}</ion-col>
      </ion-row>
      <ion-row *ngFor="let call of callList | orderBy: 'id': 'desc'">
        <ion-col *ngFor="let column of columns">
          {{ column.formatter ? column.formatter(call) : call[column.field] }}
        </ion-col>
        <ion-col>
          <ion-button (click)="view(call)">{{ "__CALLS_VIEW__" | translate }}</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
</div>
